module.exports = __webpack_public_path__ + "img/gin_fizz.361cada3.jpg";